import styled from 'styled-components'

export const ApplyBtnStyled = styled.div`
    width: 263px;
    margin: 0 auto;
    
    span {
        width: 263px;
        text-align: center;
    }
`
